export default "__VITE_ASSET__BSkosKN8__"